import { render, staticRenderFns } from "./report-student.vue?vue&type=template&id=0e9851a2&"
import script from "./report-student.vue?vue&type=script&lang=js&"
export * from "./report-student.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports